import Pusher from 'pusher-js'
import { notificationList, notificationRead, notification_redirection, homework_redirection, certificate_redirection } from '@/api/notification.js'
import {  mapActions, mapGetters } from 'vuex'

export const NotificationMixins = {

  data () {
    return {
      userInfo: JSON.parse(localStorage.userInfo),
      notificationListData:[],
      unread_notification:0
    }
  },
  created () {
    this.fetch_list()
    this.subscribe()
  },
  computed: {
    ...mapGetters(['UserThreads', 'StaffThreads', 'ClientThreads', 'GroupThreads', 'active_thread', 'tabActive', 'UserActiveThread', 'StaffActiveThread', 'ClientActiveThread', 'GroupActiveThread', 'SingleActiveThreadDetails'])
  },
  methods:{
    ...mapActions(['SET_CHAT_RELATED_TO', 'SET_UNREAD_NOTIFICATION_READ', 'SET_USER_ACTIVE_THREAD', 'SET_CLIENT_ACTIVE_THREAD', 'SET_USERS_THREADS', 'SET_STAFF_THREADS', 'SET_GROUP_THREADS', 'SET_CLIENT_THREADS', 'SET_ADMIN_ACTIVE_THREAD', 'SET_STAFF_ACTIVE_THREAD', 'SET_CLIENT_ACTIVE_THREAD', 'SET_USER_ACTIVE_THREAD', 'SET_ACTIVE_TAB', 'SET_ACTIVE_SINGLE_THREAD_DETAILS']),

    subscribe () {
      // 
      this.pusher = new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
        encrypted: true,
        cluster: 'ap2'
      })
      const customer_id = parseInt(localStorage.getItem('customer_id'))
      const userId = JSON.parse(localStorage.getItem('userInfo'))
      
      
      this.channel = this.pusher.subscribe(`customer_${customer_id}`)
      this.channel.bind(`user_${userId.id}`, (data) => {
        // 
        if (data) {
          this.showSuccessMessage('Success', `${data.notification_details}`, 'success')
          // 
          this.SET_UNREAD_NOTIFICATION_READ(this.get_unread_notification++)
          this.notificationListData.unshift({
            notification_details:data.notification_details,
            created_at:'1 sec ago'
          })
          // this.notificationListData.length = 5
        }
      })

      //For Chat received alert notification 
      this.channel = this.pusher.subscribe('chat')
      this.channel.bind(`chat_${userId.id}_User_to`, (data) => {
        if (data) {
          this.showSuccessMessage('Success',  `${data.notification_details}`, 'success')
          // 
          this.ADD_NEW_NOTIFICATION()
          this.notificationListData.unshift({
            notification_details:data.notification_details,
            created_at:'1 sec ago'
          })
          // this.notificationListData.length = 5
        }
      }) 

      //For chat from anywhere in the portal (Pusher bind_global - Channel - chat)
      const chat_channel = this.pusher.subscribe('chat')
      chat_channel.bind_global((event, data) => { 
        if (data.from_user !== this.userInfo.id) { 
          //If I am the sender then definately I don't need this call
          this.fetch_list()
        } else {
        }
     
      })
    },
    async fetch_list () {
      try {
        const { data } = await notificationList(localStorage.getItem('customer_id'), 50)
          
        this.notificationListData = data.data.results
        this.unreadCount = data.data.unread_count
        this.SET_UNREAD_NOTIFICATION_READ(data.data.unread_count)
            
      } catch (e) {
        console.log(e)
      }
    },
    redirectToRespectivePath (notification, index, type = false) {
      
      const platform_module_id = notification.platform_module_id
      const action_name = notification.action_name
      
      if (type) {
        this.notificationReadApi(notification, index)
        

        this.notificationListData[index].is_read = false
        this.SET_UNREAD_NOTIFICATION_READ('read')
      }

      switch (platform_module_id) {
      // case 39:this.sendToCommunication(notification)
      //   break
      case 3:this.sendToCourseModule(notification)
        break
      case 12:this.sendToReportModule(notification)
        break
      case 13:this.sendToHomeworkModule(notification)
        break
      case 17:this.sendToHomeworkModule(notification)
        break
      case 47:this.sendToCertificateModule(notification)
        break
      default:this.sendToDefault()
      }

      switch (action_name) {
      case 'compose': this.sendToEmail(notification)
        break
      case 'sendChat': this.sendToChat(notification)
        break
      case 'shareBlog': this.sendToBlogPost(notification)
        break
      case 'LeadActivity': this.sendToLead(notification)
        break
      default:this.sendToDefault()
      }
      
      this.$refs.notificationOpenBtn.$el.click()
    },
    async sendToChat (notification) {
      try {
        if (notification.message_details === null || notification.message_details === '') {
          this.$vs.notify({
            title: 'Warning',
            text: 'In correct chat data, try with new data',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 2000
          })
        }
        const notification_id = notification.notification_id
        const relatedTo = notification.message_details.is_client_message_type
        this.SET_CHAT_RELATED_TO(relatedTo)
        const customer_id = notification.customer_id
        const {data} = await notification_redirection(customer_id, notification_id)
        const redirection_details = data.data.redirection_details
        const user_id = redirection_details.user_id
        // const user_type = notification.from_user_type
        const user_type = data.data.redirection_details.user_type
        let activeTab = 0
        
        // eslint-disable-next-line no-unused-vars
        // if (user_type === 1) {
        //   activeTab = 0
        //   this.SET_USER_ACTIVE_THREAD(user_id)
        // } else if (user_type === 2) {
        //   activeTab = 1
        //   this.SET_CLIENT_ACTIVE_THREAD(user_id)
        // }

        if (user_type === 0) {
          activeTab = 0
          this.SET_USER_ACTIVE_THREAD(user_id)
        } else if (user_type === 1) {
          activeTab = 1
          this.SET_CLIENT_ACTIVE_THREAD(user_id)
        }

        const thread = redirection_details
        this.SET_ACTIVE_SINGLE_THREAD_DETAILS(thread)
        this.SET_ACTIVE_TAB(activeTab)
        
        setTimeout(() => {
          this.$router.push({ path: '/pages/chat' })
        }, 500)

      } catch (e) {
        console.error(e)
      }
    },
    sendToEmail (notification) {
      // const from_user_type = notification.from_user_type
      // const from_user_id = notification.from_user_id
      //const related_id = notification.related_id    
      // let query = null
      // if (from_user_type === 1) {
      //   query =  { user_id: from_user_id, related_id }
      // } else if (from_user_type === 2) {
      //   query = { client_id: from_user_id, related_id }
      // }
      const id = notification.related_id
      const query = {related_id:{id}}
      this.$router.push({ path: '/pages/email', query})
  
    },
    sendToDefault () {
      
    },
    sendToCommunication (notification) {
      
      
      if (notification.action_name === 'shareBlog') {
        this.sendToBlogPost(notification)
      } else {
        this.$router.push({name:'messaging'})
      }
    },
    sendToBlogPost (notification) {
      
      this.$router.push({name:'Blogs-Post-Details', params: { Id: notification.related_id}})
    },
    async sendToReportModule (notification) {
      const {data} = await homework_redirection(notification.customer_id, notification.related_id)
      this.$router.push({name:'QuestionsPreview',
        params: {  assignment_details: data.data.assignmentlist[0],
          assignmentApplicationType:'Shared'}})
    },
    async sendToHomeworkModule (notification) {
      const {data} = await homework_redirection(notification.customer_id, notification.related_id)
      this.$router.push({name:'QuestionsPreview',
        params: {  assignment_details: data.data.assignmentlist[0],
          assignmentApplicationType:'Shared'}})
    },
    async sendToCertificateModule (notification) {
      const {data} = await certificate_redirection(notification.customer_id, notification.related_id)
      this.$router.push({name:'CertificatePreview',
        params: {  certificte_details: data.data.certificate}})
    },
    sendToCourseModule (notification) {
      
      
      const course_id = notification.related_id
      this.$router.push({name:'coursePreview',
      
        params:{
          courseSlug:notification.course_slug_name
        }
      }).catch(() => {})
    },
    async notificationReadApi (singleData, index) {
      try {
        // 
        const payload = {
          customer_id: localStorage.getItem('customer_id'),
          notification: [singleData.notification_id]
        }
        await notificationRead(payload, index)
        

        return true
        // this.tableData[index].is_read = 1

      } catch (error) {
        console.warn(error)
      }
    },
    sendToLead (notification) {
      this.$router.push({ name: 'leadDetails', params: { leadId: notification.lead_entity_id, activityId: notification.related_id }}).catch(() => {})
    }
  }
    
}